import { AppLogoType } from '@thoughtspot/custom-style-service';
import { GlobalAlertContextProvider } from '@thoughtspot/global-alert';
import React from 'react';
import { useBlinkContextForGlobalNav } from '../../contexts/global-nav-blink-context';
import { HelpMenu } from './help-menu';
export const HelpMenuContainer = ({ isPendoHelpEnabled, learningModule, }) => {
    const { sessionService, metricsService, navService, systemConfigService, observabilityService, customStylingService, } = useBlinkContextForGlobalNav();
    const { getReleaseVersion, getBaseReleaseVersion, getHelpConfig, getOnlineDocUrl, getInAppHelpUrl, isSaaSCluster, getSupportConfigItems, isAboutInstanceModalEnabled, getClusterId, getSessionTimeZone, } = sessionService;
    const { isIntercomEnabled } = systemConfigService;
    const baseReleaseVersion = getBaseReleaseVersion();
    const releaseVersion = getReleaseVersion();
    const helpConfigList = (getHelpConfig() || []);
    const onlineDocUrl = getOnlineDocUrl();
    const inAppHelpUrl = getInAppHelpUrl();
    const saasCluster = isSaaSCluster();
    const intercomEnabled = isIntercomEnabled();
    const supportConfigItems = (getSupportConfigItems() ||
        []);
    const aboutInstanceModalEnabled = isAboutInstanceModalEnabled();
    const customStyleConfig = customStylingService.getConfig();
    const hasCustomLogo = customStyleConfig?.hasCustomImageLogo(AppLogoType.DEFAULT);
    const customLogoUrl = hasCustomLogo
        ? customStyleConfig?.getAppLogoUrl(AppLogoType.DEFAULT)
        : null;
    const instanceInfo = {
        version: releaseVersion,
        clusterId: getClusterId(),
        clusterTimezone: getSessionTimeZone(),
    };
    return (React.createElement(GlobalAlertContextProvider, null,
        React.createElement(HelpMenu, { baseReleaseVersion: baseReleaseVersion, helpItems: helpConfigList, inAppHelpUrl: inAppHelpUrl, isAboutInstanceModalEnabled: aboutInstanceModalEnabled, isIntercomEnabled: intercomEnabled, isSaaSCluster: saasCluster, learningModule: learningModule, metricsService: metricsService, onlineDocUrl: onlineDocUrl, openExternalUrlInNewTab: navService.openExternalUrlInNewTab, releaseVersion: releaseVersion, showPendoHelpMenu: isPendoHelpEnabled, stopReplay: observabilityService?.stopReplay, supportConfigItems: supportConfigItems, watchForFullReplay: observabilityService?.watchForFullReplay, instanceInfo: instanceInfo, customLogoUrl: customLogoUrl })));
};
//# sourceMappingURL=help-menu.container.js.map